import React from 'react'
import { Alert, List } from 'antd'

class ApplyFormErrorMessage extends React.Component {
  render() {
    if (!this.props.error || this.props.error.length === 0) return null
    return (
      <Alert
        message={this.props.error.length + ' error prohibited submit application:'}
        description={
          <List dataSource={this.props.error} renderItem={(item) => <List.Item key={item.errors[0]}>{item.errors[0]}</List.Item>} />
        }
        type='error'
        showIcon
        style={{ marginTop: '16px' }}
      />
    )
  }
}

export default ApplyFormErrorMessage
